"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterInput = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const Icon_1 = __importDefault(require("../Icon/Icon"));
const Container = Theme_1.styled.div `
  max-width: ${(props) => props.width ? props.width.replace(/px$/, '') + 'px' : '156px'};
  height: ${(props) => props.height ? props.height.replace(/px$/, '') + 'px' : '40px'};
  width: ${(props) => props.width ? props.width.replace(/px$/, '') + 'px' : '156px'};
  background: #fff;
  display: inline-flex;
  flex: 1;
  border: 1px solid #cccccc;
  border-radius: 20px;
  padding-right: 10px;
  padding-left: 19px;
  align-items: center;
  justify-content: center;
`;
const RightIcon = Theme_1.styled.div `
  cursor: pointer;
  width: 30px;
  flex: 0 0 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;

  & > div {
    width: 12px;
    height: 12px;
  }
`;
const LeftIcon = Theme_1.styled.div `
  width: 16px;
  flex: 0 0 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 16px;
  padding-right: 10px;

  & > div {
    width: 100%;
    height: 100%;
  }
`;
const InputContainer = Theme_1.styled.div `
  flex: 1;
`;
const Input = Theme_1.styled.input `
  font-family: ${(props) => props.theme.font.family.proximaNova};
  width: 100%;
  color: ${(props) => props.theme.gray};
  font-size: ${(props) => props.height
    ? Number(props.height.replace(/px$/, '')) * 0.4 + 'px'
    : '16px'};
  padding: 0;
  border: 0;
  &:focus {
    outline: none;
  }
  &::-webkit-input-placeholder {
    color: ${(props) => props.theme.gray3};
  }
`;
const FilterInput = (props) => {
    const containerPropsValues = { height: props.height, width: props.width };
    return (react_1.default.createElement(Container, Object.assign({ className: props.className }, containerPropsValues),
        props.icon && !props.value && (react_1.default.createElement(LeftIcon, null,
            react_1.default.createElement(Icon_1.default, { icon: "searchBlack" }))),
        react_1.default.createElement(InputContainer, null,
            react_1.default.createElement(Input, Object.assign({}, props))),
        props.value && (react_1.default.createElement(RightIcon, { onClick: props.clearSearch },
            react_1.default.createElement(Icon_1.default, { icon: "close", onClick: props.clearSearch, "data-testid": "clear-button" })))));
};
exports.FilterInput = FilterInput;
exports.default = exports.FilterInput;
//# sourceMappingURL=FilterInput.js.map